
import { ActionType } from '../actionTypes';
import { Action } from '../actions';

import { ErrorDto, UserDto } from '../../dtos'

interface AuthState {
    loading: boolean;
    error: ErrorDto | null;
    data: UserDto | null;
    type: string | null;

    isAuthenticated: boolean;
}

const initialState = {
    loading: false,
    error: null,
    data: null,
    type: null,
    isAuthenticated: false,
}

const reducer = (
    state: AuthState = initialState,
    action: Action
): AuthState => {

    switch (action.type) {


        // Register
        case ActionType.REGISTER_START:
            return { loading: true, error: null, data: null, type: action.type, isAuthenticated: false }

        case ActionType.REGISTER_SUCCESS:
            return { loading: false, error: null, data: action.payload, type: action.type, isAuthenticated: false }

        case ActionType.REGISTER_ERROR:
            return { loading: false, error: action.payload, data: null, type: action.type, isAuthenticated: false }

        case ActionType.REGISTER_COMPLETED:
            return { loading: false, error: null, data: null, type: action.type, isAuthenticated: false }


        // Login
        case ActionType.LOGIN_START:
            return { loading: true, error: null, data: null, type: action.type, isAuthenticated: false }

        case ActionType.LOGIN_SUCCESS:
            return { loading: false, error: null, data: action.payload, type: action.type, isAuthenticated: true }

        case ActionType.LOGIN_ERROR:
            return { loading: false, error: action.payload, data: null, type: action.type, isAuthenticated: false }

        case ActionType.LOGIN_COMPLETED:
            return { loading: false, error: null, data: null, type: action.type, isAuthenticated: true }


        case ActionType.LOG_OUT:
            localStorage.removeItem('userDto')
            return { ...initialState };
            

        // Forgot Password
        case ActionType.FORGOT_PASSWORD_START:
            return { loading: true, error: null, data: null, type: action.type, isAuthenticated: false }

        case ActionType.FORGOT_PASSWORD_SUCCESS:
            return { loading: false, error: null, data: action.payload, type: action.type, isAuthenticated: false }

        case ActionType.FORGOT_PASSWORD_ERROR:
            return { loading: false, error: action.payload, data: null, type: action.type, isAuthenticated: false }

        case ActionType.FORGOT_PASSWORD_COMPLETED:
            return { loading: false, error: null, data: null, type: action.type, isAuthenticated: false }


        // Fetch user data
        case ActionType.FETCH_USER_DATA_START:
            return { loading: true, error: null, data: null, type: action.type, isAuthenticated: true }

        case ActionType.FETCH_USER_DATA_SUCCESS:
            return { loading: false, error: null, data: action.payload, type: action.type, isAuthenticated: true }

        case ActionType.FETCH_USER_DATA_ERROR:
            return { loading: false, error: action.payload, data: null, type: action.type, isAuthenticated: true }

        case ActionType.FETCH_USER_DATA_COMPLETED:
            return { loading: false, error: null, data: action.payload, type: action.type, isAuthenticated: true }


        // Reset Password
        case ActionType.RESET_PASSWORD_START:
            return { loading: true, error: null, data: null, type: action.type, isAuthenticated: false }

        case ActionType.RESET_PASSWORD_SUCCESS:
            return { loading: false, error: null, data: null, type: action.type, isAuthenticated: false }

        case ActionType.RESET_PASSWORD_ERROR:
            return { loading: false, error: action.payload, data: null, type: action.type, isAuthenticated: false }

        case ActionType.RESET_PASSWORD_COMPLETED:
            return { loading: false, error: null, data: null, type: action.type, isAuthenticated: false }


        // Register Email
        case ActionType.CONFIRM_EMAIL_START:
            return { loading: true, error: null, data: null, type: action.type, isAuthenticated: false }

        case ActionType.CONFIRM_EMAIL_SUCCESS:
            return { loading: false, error: null, data: null, type: action.type, isAuthenticated: false }

        case ActionType.CONFIRM_EMAIL_ERROR:
            return { loading: false, error: action.payload, data: null, type: action.type, isAuthenticated: false }

        case ActionType.CONFIRM_EMAIL_COMPLETED:
            return { loading: false, error: null, data: null, type: action.type, isAuthenticated: false }

        // the default switch case must be included as followed:
        default:
            return state;
    }
}

export default reducer;